import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpRequest } from '@angular/common/http';


@Component({
  selector: 'app-careers-detail',
  templateUrl: './careers-detail.component.html',
  styleUrls: ['./careers-detail.component.scss']
})
export class CareersDetailComponent implements OnInit {
  public title;
  detailedObj = {
    company_name: 'Benutech',
    date:'Jan 1 2020'
  };

  public applyForm;
  public hrefLink;

  constructor(private formBuilder: FormBuilder, private http: HttpClient) { }

  ngOnInit() {
    this.hrefLink = location.href.split('/').slice(4, 5)[0];

    if (this.hrefLink === 'product-application-specialists') {
      this.title = 'Product Application Specialists';
    } else if (this.hrefLink === 'customer-service-representative') {
      this.title = 'Customer Service Representative';
    } else if (this.hrefLink === 'business-development') {
      this.title = 'Business Development - Team';
    } else if (this.hrefLink === 'application-developer') {
      this.title = 'Application Developer';
    }

    this.applyForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.required]],
      comment: ['', [Validators.required]],
      inputFile: ['', [Validators.required]]
    });
  }

  onSubmit() {
    let baseAPI;

    const headers = new Headers({ 'Content-Type': 'application/json; charset=UTF-8' });

    baseAPI = 'https://api.rebodata.net/benutechApi.php?method=notify&';
    this.http.post(baseAPI +
      'email=' + this.applyForm.value.email + '&name='
      + this.applyForm.value.name + '&content=' + this.applyForm.value.comment + '$_FILES[' + this.applyForm.value.inputFile + ']', headers)
      .subscribe(
        data  => {
          console.log(data);
        }
      );
  }

}



// WEBPACK FOOTER //
// /Users/muhammadfarhan/Documents/benutech/benutechv2/client/src/app/pages/careers/careers-detail/careers-detail.component.ts